define('charts/layers/distancelayer',["require", "exports", "../../baseline/colors", "../../tracks/track-enabled", "../../tracks/track-state"], function (require, exports, colors_1, trackEnabled, trackState) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DistanceLayer = void 0;
    var DistanceLayer = /** @class */ (function () {
        function DistanceLayer(options) {
            this.transition = false;
            this.options = options;
        }
        DistanceLayer.prototype.init = function (chart) {
            var _this = this;
            // Add svg group
            this.svgGroup = chart.layers.space.append("g")
                .attr("class", "distance paths")
                .style("fill", "none");
            // Construct d3 line
            this.distanceLine = d3.line()
                .x(function (d) { return chart.xAxis.scale(_this.options.fx(d)); })
                .y(function (d) { return chart.yAxis[0].scale(_this.options.fy(d)); });
        };
        DistanceLayer.prototype.update = function (chart) {
            var _this = this;
            // Update the flight profile lines
            var trackList = Object.keys(trackEnabled.enabled).map(function (k) { return trackEnabled.enabled[k]; }); // TODO: Object.values ES2017
            var path = this.svgGroup.selectAll("path.flight-path")
                .data(trackList);
            var merged = path.enter()
                .append("path")
                .attr("class", "flight-path")
                .merge(path)
                .style("stroke", function (d) { return (0, colors_1.trackColor)(d); })
                .style("stroke-opacity", function (d) {
                var currentHighlight = trackState.highlight.get();
                if (currentHighlight && currentHighlight !== d.track_id) {
                    return 0.4;
                }
                else {
                    return 1;
                }
            })
                .style("stroke-width", function (d) {
                if (trackState.highlight.get() === d.track_id) {
                    return "6px";
                }
                else if (d.trackType === "laser") {
                    return "4px";
                }
                else {
                    return "2px";
                }
            });
            if (this.transition) {
                this.transition = false;
                merged.transition()
                    .attr("d", function (d) { return _this.distanceLine(d.trimmedData()); });
            }
            else {
                merged
                    .attr("d", function (d) { return _this.distanceLine(d.trimmedData()); });
            }
            path.exit().remove();
        };
        /** Animate the transition of the next update */
        DistanceLayer.prototype.transitionNext = function () {
            this.transition = true;
        };
        DistanceLayer.prototype.remove = function () {
            this.svgGroup.remove();
        };
        return DistanceLayer;
    }());
    exports.DistanceLayer = DistanceLayer;
});
//# sourceMappingURL=/assets/javascripts/charts/layers/distancelayer.js.map;
